
import Header from '../../components/feature/Header';
import HeroBanner from '../../components/feature/HeroBanner';
import FeaturedGems from '../../components/feature/FeaturedGems';
import GalleryShowcase from '../../components/feature/GalleryShowcase';
import BrandIntro from '../../components/feature/BrandIntro';
import HotJewelry from '../../components/feature/HotJewelry';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroBanner />
      <div id="featured-gems">
        <FeaturedGems />
      </div>
      <div id="gallery-showcase">
        <GalleryShowcase />
      </div>
      <div id="brand-intro">
        <BrandIntro />
      </div>
      <div id="hot-jewelry">
        <HotJewelry />
      </div>
      <Footer />
    </div>
  );
}
